<template>
  <div class="NewMedia">
    <navBarNoLab :onIndex="0"></navBarNoLab>
    <div class="Content">
      <!-- 第一屏视频 -->
      <div class="banner">
        <div class="video">
          <video class="javaVideo" autoplay loop muted>
            <source
              class="javaSource"
              src="./images/banner.mp4"
              type="video/mp4"
            />
          </video>
          <span class="bannerfont"
            ><img src="./images/banner_font.png" width="1012px" alt=""
          /></span>
        </div>
      </div>
      <!-- end -->
      <!-- 第七屏 项目专栏-->
      <div id="scrollTg6" class="screen sSeven" >
        <div v-if="eighthScreen.length > 0">
          <theProjectColumn
            :eighthScreen="eighthScreen"
            :sevItemsKeys="sevItemsKeys"
          />
        </div>
        
      </div>
      <!-- 第二屏 真项目才有好成绩 -->
      <div id="scrollTg1" class="screen sTwo">
        <goodScore />
      </div>
      <!-- end -->
      <!-- 第三屏 无基础“高薪就业” 转行“跳槽大厂”  -->
      <div id="scrollTg2" class="screen sTree">
        <jobHopping :streeKeyformShow="streeKeyformShow" />
      </div>
      <!-- end -->
      <!-- 第四屏 一直被模仿 从未被超越 -->
      <div id="scrollTg3" class="screen sFour">
        <Surpass :streeKeyfourShow="streeKeyfourShow" />
      </div>
      <!-- end -->
      <!-- 第五屏 实训作业及时批改&其他辅助训练-->
      <div id="scrollTg4" class="screen sFives">
        <practicalTraining
          :sFivesContAnim="sFivesContAnim"
          :fifthScreen="fifthScreen"
        />
      </div>
      <!-- end -->
      <!-- 第六屏 急你所需，项目满足四大不同人群需求-->
      <div id="scrollTg5" class="screen sSix">
        <peopleDemand :sixthScreen="sixthScreen" :sSixKeys="sSixKeys" />
      </div>
      <!-- end -->
      
      <!-- end -->
      <!-- 最后一屏  常见问题与帮助-->
      <div id="scrollTg7" class="screen sEight">
        <helpProblem :showRound="showRound" />
      </div>
      <!-- 关于我们 -->
      <div id="scrollTg8" class="screen sNine">
        <aboutUs :nineShowRound="nineShowRound" />
      </div>
      <!-- end -->
    </div>
    <MenuAdd ref="editMenu"></MenuAdd>
    <MenuListAdd ref="editMenuList"></MenuListAdd>
    <bottom-widge></bottom-widge>

    <el-dialog :visible.sync="openBigImg" top="10%" width="1300px">
      <div class="HomeDialogCont">
        <div class="closeTag" @click="() => (openBigImg = false)">
          <img src="./../../../../assets/common/img/close.png" width="15px" />
        </div>
        <!-- <img src="./images/img_process_big.png" width="100%" alt="" /> -->
        <div class="mapArea">
          <div class="area"></div>
          <div class="showInfo">
            <p>开发验收</p>
            <p>业务验收</p>
            <p>设计验收</p>
            <p>性能验收</p>
            <p>安全验收</p>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import navBarNoLab from "./../../../components/navBarNoLab";
import bottomWidge from "./../../../components/bottomWidge";
import { JavaHome } from "../../../../gqlapi/JavaHome.js";
import MenuAdd from "./../../../components/video";
import MenuListAdd from "./../../../components/videoList";
import goodScore from "../newMedia/components/goodScore";
import jobHopping from "../newMedia/components/jobHopping";
import Surpass from "../newMedia/components/surpass";
import practicalTraining from "../newMedia/components/practicalTraining";
import peopleDemand from "../newMedia/components/peopleDemand";
import theProjectColumn from "../newMedia/components/theProjectColumn";
import helpProblem from "../newMedia/components/helpProblem";
import aboutUs from "../newMedia/components/aboutUs";
export default {
  name: "layout",
  components: {
    navBarNoLab,
    bottomWidge,
    MenuAdd,
    MenuListAdd,
    goodScore,
    jobHopping,
    Surpass,
    practicalTraining,
    peopleDemand,
    theProjectColumn,
    helpProblem,
    aboutUs,
  },
  data() {
    return {
      bannerInfo: {},
      openBigImg: false,
      twoItemsKeys: false,
      streeKeyformShow: false,
      streeKeyfourShow: false,
      showRound: false,
      sFivesContAnim: false,
      showRoundA: false,
      sSixKeys: false,
      sevItemsKeys: true,
      nineShowRound: false,
      dialogVisied: false,
      SecondScreen: [
        {
          id: "1",
          title: "广州新媒体3期",
          desc: "学习3个月，Offer",
          className: "GzIcon",
          pay: "13.4k",
          praise: "",
        },
        {
          id: "2",
          title: "深圳新媒体17期",
          desc: "学习3个月，Offer",
          desc1: "",
          desc2: "",
          className: "SzIcon",
          pay: "18k",
          praise: "",
        },
        {
          id: "3",
          title: "北京新媒体17期",
          desc: "学习2个月，",
          desc1: "吸粉",
          desc2: "每月盈利",
          className: "BjIcon",
          pay: "2k-3k",
          praise: "5000k",
        },
        {
          id: "4",
          title: "深圳新媒体18期",
          desc: "学习1个月，吸粉",
          desc1: "",
          desc2: "",
          className: "SzIcon",
          pay: "",
          praise: "12W",
        },
        {
          id: "5",
          title: "上海新媒体7期",
          desc: "学习2个月，吸粉",
          desc1: "",
          desc2: "获赞",
          className: "ShIcon",
          pay: "233w+",
          praise: "29w+",
        },
      ],
      fifthScreen: [
        {
          id: "1",
          title: "实训作业点评",
          url: "./images/sxPic.jpg",
        },
        {
          id: "2",
          title: "某社群运营方案批改",
          url: "./images/sqPic.jpg",
        },
        {
          id: "3",
          title: "某微信号运营作业批改",
          url: "./images/wxPic.jpg",
        },
      ],
      sixthScreen: [
        {
          id: "1",
          title: "自由职业、创业者",
          url: require("./images/zypic.png"),
        },
        {
          id: "2",
          title: "应届大学毕业生",
          url: require("./images/yingjie.png"),
        },
        {
          id: "3",
          title: "互联网转行人员",
          url: require("./images/zhpic.png"),
        },
        {
          id: "4",
          title: "学历不高、00后人群",
          url: require("./images/xueli.png"),
        },
      ],
      eighthScreen: [],

      dialogData: {},
    };
  },

  created() {
    this.getNewMediaDataes();
  },
  mounted() {
    // 滚动事件
    window.addEventListener("scroll", this.scrollHandle);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollHandle);
  },
  methods: {
    // 初始化数据获取
    getNewMediaDataes() {
      this.$axios
        .post("/api", {
          operationName: "JavaHome",
          variables: {
            id: 3,
          },
          query: JavaHome,
        })
        .then((res) => {
          const data = res.data.data.javaHome;
          this.bannerInfo = data.FirstScreen;
          this.eighthScreen = data.objectLists.length > 0 ? data.objectLists.filter(function(item){
            if(item.isOpen){
              return item
            }
          }): [];
        })
        .catch((res) => {
          console.log("JavaHome 请求出错：" + res);
        });
    },
    // 滚动事件
    scrollHandle() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // let tag1 = document.querySelector("#scrollTg1");
      let tag2 = document.querySelector("#scrollTg2");
      let tag3 = document.querySelector("#scrollTg3");
      let tag4 = document.querySelector("#scrollTg4");
      let tag5 = document.querySelector("#scrollTg5");
      let tag6 = document.querySelector("#scrollTg6");
      let tag7 = document.querySelector("#scrollTg7");
      let tag8 = document.querySelector("#scrollTg8");

      // if (scrollTop >= tag1.offsetTop) {
      //   this.twoItemsKeys = true;
      // }
      if (scrollTop >= tag2.offsetTop - 600) {
        this.streeKeyformShow = true;
      }

      if (scrollTop >= tag3.offsetTop - 680) {
        this.streeKeyfourShow = true;
      }
      if (scrollTop >= tag4.offsetTop - 680) {
        this.sFivesContAnim = true;
      }
      if (scrollTop >= tag5.offsetTop - 680) {
        this.sSixKeys = true;
      }
      if (scrollTop >= tag6.offsetTop - 680) {
        // this.sevItemsKeys = true;
      }
      if (scrollTop >= tag7.offsetTop - 680) {
        this.showRound = true;
      }
      if (scrollTop >= tag8.offsetTop - 600) {
        this.nineShowRound = true;
      }
    },
  },
};
</script>

<style src="./style.scss" rel="stylesheet/scss" lang="scss" scoped></style>
<style lang="scss">
.HomeModular .el-dialog__header {
  display: none;
}
.HomeModular .el-dialog {
  min-width: 1180px;
  max-width: 1440px;
  top: 50%;
  transform: translateY(-50%);
}
.HomeModular .HomeDialogCont {
  background: #fff;
  position: relative;
  .closeTag {
    position: absolute;
    cursor: pointer;
    right: 20px;
    top: 20px;
  }
  .mapArea {
    position: absolute;
    right: 12%;
    top: 38.5%;
    .area {
      position: absolute;
      background: red;
      opacity: 0;
      width: 100px;
      height: 20px;
      right: 0px;
      cursor: pointer;
    }
    .showInfo {
      position: relative;
      display: none;
      text-align: center;
      padding: 8px 0;
      top: 30px;
      width: 107px;
      font-size: 12px;
      color: #181818;
      line-height: 28px;
      opacity: 1;
      background: #ffffff;
      border-radius: 7px;
      box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.07);
    }
    &:hover .showInfo {
      display: block;
    }
  }
}
@keyframes showVsCardsR {
  0% {
    transform: translate(0px, 0px);
    // transform: rotate(0deg);
  }
  50% {
    transform: translate(0, -30px); /*往Y轴方向跳动*/
    // transform: rotate(360deg);
  }
  100% {
    transform: translate(0px, 0px);
    // transform: rotate(360deg);
  }
}
@keyframes showServiceR {
  0% {
    right: -100px;
    opacity: 0;
  }
  100% {
    right: 0px;
    opacity: 1;
  }
}
@keyframes keysUpShow {
  0% {
    opacity: 0;
    top: 100px;
  }
  100% {
    opacity: 1;
    top: 0px;
  }
}
@keyframes bannerFontUpShow {
  0% {
    opacity: 0;
    top: 60%;
  }
  100% {
    opacity: 1;
    top: 50%;
  }
}
@keyframes bannerTitleUpShow {
  0% {
    opacity: 0;
    top: 60px;
  }
  100% {
    opacity: 1;
    top: 0px;
  }
}
@keyframes moveIcon {
  0%,
  35% {
    -webkit-transform: rotate(8deg);
    transform: rotate(8deg);
  }
  40% {
    -webkit-transform: rotate(-8deg);
    transform: rotate(-8deg);
  }
  50% {
    -webkit-transform: rotate(8deg);
    transform: rotate(8deg);
  }
  55% {
    -webkit-transform: rotate(-8deg);
    transform: rotate(-8deg);
  }
  60% {
    -webkit-transform: rotate(8deg);
    transform: rotate(8deg);
  }
  65% {
    -webkit-transform: rotate(-8deg);
    transform: rotate(-8deg);
  }
  70% {
    -webkit-transform: rotate(8deg);
    transform: rotate(8deg);
  }
  75% {
    -webkit-transform: rotate(-8deg);
    transform: rotate(-8deg);
  }
  80% {
    -webkit-transform: rotate(8deg);
    transform: rotate(8deg);
  }
  85% {
    -webkit-transform: rotate(-8deg);
    transform: rotate(-8deg);
  }
  90% {
    -webkit-transform: rotate(8deg);
    transform: rotate(8deg);
  }
  95% {
    -webkit-transform: rotate(-8deg);
    transform: rotate(-8deg);
  }
  100% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
}

@keyframes sFivesShowFont {
  from {
    opacity: 0;
    transform: translateY(10%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
